import React from 'react';
import Slider from 'react-slick';
import AdvertListItem from '../AdvertList/components/AdvertListItem';

const SimilarProducts = ({ products }) => {
  const settings = {
    arrows: true,
    autoplay: false,
    dots: false,
    infinite: products?.length > 3,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1130,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="container">
      <div className="similar-products">
        <Slider {...settings}>
          {
            products && products?.map((product) => (
              <AdvertListItem
                product={product}
                key={product.id}
              />
            ))
          }
        </Slider>
      </div>
    </div>
  );
};

export default SimilarProducts;
